import script from "./DiaryEntryForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiaryEntryForm.vue?vue&type=script&setup=true&lang=ts"

import "./DiaryEntryForm.vue?vue&type=style&index=0&id=4921a552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4921a552"]])

export default __exports__